import { forwardRef } from 'react';

/**
 * A spinning busy indicator (spec §7.2). Pass `label` when the spinner is the
 * only signal that something is loading (renders `role="status"` +
 * `aria-label`); omit it when adjacent visible text already announces the
 * loading state, in which case the spinner stays `aria-hidden`.
 *
 * @param {object} props
 * @param {'lg'} [props.size]
 * @param {string} [props.label]
 * @param {string} [props.className]
 */
export const Spinner = forwardRef(function Spinner({ size, label, className = '', ...rest }, ref) {
  return (
    <span
      ref={ref}
      className={`etch-spinner ${className}`.trim()}
      data-size={size}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      {...rest}
    />
  );
});

export default Spinner;
